import React from "react";
import { Box, Typography, styled, SxProps, Theme } from "@mui/material";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import { useTranslation } from "react-i18next";
import SurfaceSection from "../Common/SurfaceSection";

interface LocationStaffCardProps {
    nameList: string[];
    sx?: SxProps<Theme>;
}

const StaffRow = styled(Box)`
    display: flex;
    flex-wrap: wrap;
    gap: ${({ theme }) => theme.spacing(1)};
    justify-content: center;
    padding-top: ${({ theme }) => theme.spacing(0.5)};
`;

const StaffContainer = styled(SurfaceSection)`
    max-height: ${({ theme }) => theme.spacing(14)};
    text-align: center;
    ${({ theme }) => theme.breakpoints.up('md')} {
        overflow-y: auto;
    }
`;

const EmptyBox = styled(Box)`
    align-items: center;
    color: ${({ theme }) => theme.palette.text.disabled};
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing(0.5)};
    padding-top: ${({ theme }) => theme.spacing(0.5)};
`;

const NameBadge = styled(SurfaceSection)`
    height: auto;
    width: auto;
`;

const LocationStaffCard: React.FC<LocationStaffCardProps> = ({ nameList, sx }) => {
    const { t } = useTranslation("common");

    return (
        <StaffContainer sx={sx}>
            <Typography variant="subtitle2" color="text.secondary">
                {t("staff")}
            </Typography>
            {nameList.length === 0 ? (
                <EmptyBox>
                    <PeopleAltOutlinedIcon fontSize="small" />
                    <Typography variant="caption">{t("no_staff_checked_in")}</Typography>
                </EmptyBox>
            ) : (
                <StaffRow>
                    {nameList.map((name, index) => (
                        <NameBadge key={index}>
                            <Typography variant="body2">{name}</Typography>
                        </NameBadge>
                    ))}
                </StaffRow>
            )}
        </StaffContainer>
    );
};

export default LocationStaffCard;
